import {mapState} from "vuex";
import _ from 'lodash';

let facetRequests = {
        "Science": [
            {
                "type": "YEAR",
                "calculate": true,
                "facetId": null
            },
            {
                "type": "SYSTEM_KEYWORDS",
                "calculate": true,
                "facetId": null
            },
            {
                "type": "CUSTOM",
                "calculate": true,
                "facetId": "trend"
            },
            {
                "type": "CUSTOM",
                "calculate": true,
                "facetId": "industry"
            },
            {
                "type": "COUNTRIES",
                "calculate": true,
                "facetId": null
            },
            {
                "type": "COUNTRIES_ALIGNMENT",
                "calculate": true,
                "facetId": null
            },
            {
                "type": "COMPANIES",
                "calculate": true,
                "facetId": null
            },
            {
                "type": "SOURCE_TYPE",
                "calculate": true,
                "facetId": null
            },
            {
                "type": "SOURCE_SUBTYPE",
                "calculate": true,
                "facetId": null
            },
            {
                "type": "ASJC_MAIN",
                "calculate": true,
                "facetId": null
            },
            {
                "type": "ASJC",
                "calculate": true,
                "facetId": null
            },
            {
                "type": "SYSTEM_KEYWORDS_SIGNIFICANT",
                "calculate": true,
                "facetId": null
            },
            {
                "type": "JOURNAL_RATE",
                "calculate": true,
                "facetId": null
            },
            {
                "type": "GRANT_COMPANIES",
                "calculate": true,
                "facetId": null
            },
            {
                "type": "AUTHORS",
                "calculate": true,
                "facetId": null
            },
            {
                "type": "QUERY_ELEMENTS",
                "calculate": true,
                "facetId": null
            }
        ]
    },
    stdFilter = {
        "queryFields": [
            "description",
            "systemKeywords",
            "title"
        ],
        "spam": false,
        "duplicate": false,
        "semantic": false,
        "offset": 0,
        "count": 0,

    }


export default {
    computed: {
        ...mapState({
            userInfo: state => state.userInfo,
            notionsDict: state => state.notions,
        }),
        allowed() {
            return this.$store.state.allowedActions;
        },
        userRoles() {
            return this.$store.state.userInfo.roles;
        },
        isDev() {
            return this.userInfo.roles.indexOf('DEV') >= 0;
        },
        isBeta() {
            return this.userInfo.roles.indexOf('BETA_TESTER') >= 0;
        },
        isAdmin() {
            return this.isDev || this.userRoles.indexOf('ADMIN') >= 0;
        },
        isSciPro() {
            return this.userRoles.indexOf('PRIVATE_SCIENCE_SEARCH') >= 0;
        },
    },
    data() {
        return {
            popularQueries: {
                blockchainDevelopment: {
                    title: "Развитие Blockchain",
                    restriction: 'PRIVATE_SCIENCE_SEARCH',
                    type: 'Science',
                    query: "Blockchain",
                    facets: [
                        [{
                            "type": "YEAR",
                            "values": ["2024"]
                        }, {
                            "type": "CUSTOM",
                            "facetId": "trend",
                            "values": [
                                "artificial_intelligence"
                            ]
                        }], [{
                            "type": "YEAR",
                            "values": ["2023"]
                        }, {
                            "type": "CUSTOM",
                            "facetId": "trend",
                            "values": [
                                "artificial_intelligence"
                            ]
                        },],
                    ]

                },
                indianTransportDevelopment: {
                    title: "Развитие искусственного интеллекта в сфере транспорта в Индии",
                    query: '"Artificial Intelligence"',
                    restriction: 'PRIVATE_SCIENCE_SEARCH',
                    type: 'Science',
                    facets: [
                        [{
                            "type": "YEAR",
                            "values": ["2024"]
                        }, {
                            "type": "CUSTOM",
                            "facetId": "industry",
                            "values": [
                                "transportation"
                            ]
                        }, {
                            "type": "COUNTRIES",
                            "values": ["india"]
                        }], [{
                            "type": "YEAR",
                            "values": ["2023"]
                        }, {
                            "type": "CUSTOM",
                            "facetId": "industry",
                            "values": [
                                "transportation"
                            ]
                        }, {
                            "type": "COUNTRIES",
                            "values": ["india"]
                        }],
                    ]
                },
                AIHealthCareByCountries: {
                    title: "Искусственный интеллект в сфере здоровья по странам",
                    query: '"Artificial Intelligence"',
                    restriction: 'PRIVATE_SCIENCE_SEARCH',
                    type: 'Science',
                    facets: [
                        [{
                            "type": "COUNTRIES",
                            "values": ["india"]
                        }, {
                            "type": "CUSTOM",
                            "facetId": "industry",
                            "values": [
                                "health_care"
                            ]
                        }], [{
                            "type": "COUNTRIES",
                            "values": ["china"]
                        }, {
                            "type": "CUSTOM",
                            "facetId": "industry",
                            "values": [
                                "health_care"
                            ]
                        }], [{
                            "type": "COUNTRIES",
                            "values": ["united states"]
                        }, {
                            "type": "CUSTOM",
                            "facetId": "industry",
                            "values": [
                                "health_care"
                            ]
                        }],
                    ]
                }
            }

        }
    },
    methods: {
        notionName(id) {
            return (this.notionsDict.map[id] || {}).name || 'Undefined'
        },
        formatQueryNotions(text, type = "html") {
            if (text) {
                let regex = /<\d*>/g;
                let _query = '';
                let tags = text.match(regex);
                let words = text.split(regex);
                let notions = tags ? tags.map(it => {
                    // return '<span class="notion">' + it.replace(/[<>]/g, "") + '</span>';
                    return (type === 'html') ? '<span class="notion">' + this.notionName(it.replace(/[<>]/g, "")) + '</span> ' : '<' + this.notionName(it.replace(/[<>]/g, "")) + '>';
                }) : '';
                words.forEach((it, i) => {
                    _query += it + (notions[i] || '');
                })
                return _query;
            }
        },
        createFacetRequest(data) {
            let filters = [];
            if (data) {
                filters.push(this.makeFacetFilter(data))
                data.facets.forEach(facet => {
                    let _filter = this.makeFacetFilter(data),
                        selectedItems = []
                    facet.forEach(facItem => {
                        let _thisFac = (_filter.facets.requests.find(req => {
                            return req.type === facItem.type && (!facItem.facetId || req.facetId === facItem.facetId)
                        }) || {})
                        _thisFac.values = facItem.values;
                        _thisFac.id = facItem.type + (facItem.facetId || '')
                        selectedItems = selectedItems.concat(facItem.values);
                    });

                    _filter.selectedItems = _.uniq(selectedItems).map(it => {
                        return _.upperFirst((it || '').replace(/_/g, ' ') || 'undefined');
                    })
                    filters.push(_filter)
                })
                // console.log('__ filters __', filters, selectedFacetIds);
                return filters;
            }
        },
        handleError(err) {
            let self = this;
            if (err.response && err.response.data.message) {
                let _msg = ((((err.response?.data?.message || '').split('number 0') || ['', ''])[1] || err.response?.data?.message) || '').replace(/\^/g, '')
                this.$alert(_msg, 'Внимание!');
            }
            self.loading = false;
        },
        makeFacetFilter(data) {
            let filter = _.merge({}, stdFilter)
            filter.query = data.query;
            filter.types = [data.type];
            filter.name = data.title;
            filter.facets = {requests: _.cloneDeep(facetRequests[data.type])}
            return filter;
        },
        handleShowHelp(params = '') {
            window.open(this.$router.resolve({name: 'FAQ'}).href + '/' + params || 'SearchOperators', '_blank');
        },


    }
}
